import { render, staticRenderFns } from "./formatted-instructions-input.vue?vue&type=template&id=11748df3&scoped=true"
import script from "./formatted-instructions-input.vue?vue&type=script&lang=js"
export * from "./formatted-instructions-input.vue?vue&type=script&lang=js"
import style0 from "./formatted-instructions-input.vue?vue&type=style&index=0&id=11748df3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11748df3",
  null
  
)

export default component.exports